const PACKAGE_VERSION = "0.50.1";
const TARGETED_RPC_VERSION = "1.20.0";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
//# sourceMappingURL=version.js.map
